import { FC } from 'react';

import { Catalog } from 'src/models/searchCatalogList';

import CatalogLink from 'src/pages/SearchCatalogList/components/CatalogLinks/CatalogLink';

import styles from './catalog-links.less';

interface CatalogLinksProps {
    catalogs: Catalog[];
}

const CatalogLinks: FC<CatalogLinksProps> = ({ catalogs }) => {
    return (
        <div className={styles.catalogLinks}>
            {catalogs.map((catalog) => (
                <CatalogLink key={catalog.catalogPath} catalog={catalog} />
            ))}
        </div>
    );
};

export default CatalogLinks;
